import './formGenerator.css'
import IndonesiaFlag from "../IndonesiaFlag";
import { useTranslation } from "react-i18next";

const InputHeader = ({ field, index, error }) => {
    const { t } = useTranslation();

    const iconMap = {
        indonesiaFlag: <IndonesiaFlag />,
    };

    const isRequired = Boolean(field?.mandatory ?? field?.required);

    return (
        <div className="input-header">
            {field?.label && (
                <h5>
                    {index ? `${index}. ` : null}
                    <span>{t(field.label)}</span>
                    {isRequired && <span className="required">*</span>}
                </h5>
            )}

            {field?.description && (
                <h6>
                    <div style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                        {field.icon && iconMap[field.icon]}
                        {t(field.description)}
                    </div>
                </h6>
            )}

            {typeof error === "string" && <h6>{error}</h6>}
        </div>
    );
};

export default InputHeader;
